import { ArrowUpOutlined, UnlockOutlined } from "@ant-design/icons";
import { FC } from "react";

import styles from "./VoiceRecordLock.module.scss";

type Props = {
  percentToLock: number;
  locked: boolean;
  recording: boolean;
};

export const VoiceRecordLock: FC<Props> = ({
  percentToLock,
  locked,
  recording,
}) => {
  return (
    <div
      className={styles.voice_record_lock}
      data-locked={locked}
      data-recording={recording}
      data-percent={percentToLock}
      style={{
        height: percentToLock === 100 ? 70 : 70 * ((100 - percentToLock) / 100),
      }}
    >
      <UnlockOutlined />
      <ArrowUpOutlined
        className="absolute"
        style={{
          bottom: 5,
          opacity:
            percentToLock === 100 ? 1 : 0.5 * ((100 - percentToLock) / 100),
        }}
      />
    </div>
  );
};
